import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TranslateResults } from 'src/app/models/translate-results.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-trace-dialog',
    templateUrl: './trace-dialog.component.html',
    styleUrls: ['./trace-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class TraceDialogComponent {
  results = inject<TranslateResults>(MAT_DIALOG_DATA);
}
